module.exports = "<mat-form-field>\n  <input matInput name=\"{{name}}\" placeholder=\"{{placeholder}}\" [ngModel]=\"value\" (ngModelChange)=\"change($event)\" \n    [readonly]=\"readonly\" [textMask]=\"{mask: mascara}\">\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-mask/bra-mask.component.html
// module id = ../../../../../src/app/componentes/bra-mask/bra-mask.component.html
// module chunks = main